import SettingsSectionItem from "./SettingsSectionItem";
import posthogEvents from "@app/config/posthog/posthog-events";
import { localStorageKey } from "@app/state/store";
import { confirm } from "@lib/common/components/modals/modals";
import { notifications } from "@lib/notification/notification";
import { Button, List, Stack, Text } from "@mantine/core";
import { usePostHog } from "posthog-js/react";

export default function Settings() {
  const posthog = usePostHog();

  function clearLocalStorage() {
    posthog.capture(posthogEvents.settings.clear_local_storage_button_click);
    confirm({
      title: "Clear local storage",
      children: (
        <Stack>
          <Text size="sm">This will permanently delete the following:</Text>
          <List>
            <List.Item>
              <Text size="sm">Selected color scheme</Text>
            </List.Item>
          </List>
          <Text c="dimmed" size="xs">
            You may have to refresh the app for all changes to take effect.
          </Text>
        </Stack>
      ),
      labels: { confirm: "Clear" },
      danger: true,
      onConfirm: () => {
        localStorage.removeItem(localStorageKey);
        notifications.success("Local storage cleared.");
      }
    });
  }

  return (
    <Stack gap="xl" w={700} mih={200}>
      <SettingsSectionItem title="Local storage" description="Clear all locally stored data.">
        <Button color="gray" variant="outline" onClick={clearLocalStorage}>
          Clear
        </Button>
      </SettingsSectionItem>
    </Stack>
  );
}
